import React, { useEffect, useState } from "react";
import avatar from "../../../images/no-img-9.jpg";
import groupImage from "../../../images/e-2.jpg";
import axios from "axios";
import toast from "react-hot-toast";
import { confirmAlert } from "react-confirm-alert";
import { useAtom } from "jotai";
import {
  gbState,
  globalUserStatus,
  gbMessageState,
} from "../../../components/shared/GlobalState";
import Modal from "../../../components/Modal/Modal";
import ComposeMail from "./ComposeMail";
import { HiOutlineMailOpen, HiOutlineUserAdd, HiOutlineSearch, HiX, HiOutlineMail, HiOutlineUser } from 'react-icons/hi';

const ChatBuddySection = () => {
  const [{ errorLogApi, placeHolderText, Category, user }] = useAtom(gbState);
  const [userGlobal, setUserGlobal] = useAtom(globalUserStatus);
  const [, setShowMessageComponent] = useAtom(gbMessageState);
  const [showModal, setShowModal] = useState(false);
  const [recipient, setRecipient] = useState();
  const [buddies, setBuddies] = useState([]);
  const [list_buddies, setListBuddies] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const toggleModal = () =>{
    setShowModal(!showModal)
  }
  useEffect(() => {
    const updateBuddyList = () => {
      let userToken = localStorage.getItem("token");
      const config = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/user/buddies-details`,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        data: { buddies: userGlobal?.buddies },
      };

      axios(config)
        .then(function (response) {
          //toast.success("Request Sent Successfully.");
          // console.log(response?.data);
          setBuddies(response?.data);
        })
        .catch(function (error) {
          toast.error(error?.response?.data?.message);
          errorLogApi(error, "AssetInwardChild", "/asset/add");
          // console.log(error);
        });
    };
    updateBuddyList();
  }, [userGlobal?.buddies]);

  const removeBuddy = (buddyId) => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/user/remove-buddy`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { userId: userGlobal?._id, buddyId },
    };
    axios(config)
      .then(function (response) {
        //toast.success("Request Sent Successfully.");
        setUserGlobal(response?.data);
      })
      .catch(function (error) {
        toast.error(error?.response?.data?.message);
        errorLogApi(error, "AssetInwardChild", "/asset/add");
        // console.log(error);
      });
  };

  const removeBuddyfromList = (id) => {
    confirmAlert({
      title: "",
      message: "Are you sure to remove?",
      buttons: [
        {
          label: "Yes",
          onClick: () => removeBuddy(id),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  const handleRecipient = (id = null) => {
    setRecipient(id);
    setShowModal(!showModal);
  };

  // Filter buddies based on search query
  const filteredBuddies = buddies.filter((buddy) => {
    const fullName = `${buddy?.first_name} ${buddy?.last_name}`.toLowerCase();
    return fullName.includes(searchQuery.toLowerCase());
  });

  return (
    <div className="bg-white rounded-xl shadow-sm">
      {showModal && (
        <Modal onClose={toggleModal}>
          <h2 className="mb-4 text-xl font-bold">Compose Email</h2>
          <ComposeMail
            user={user}
            toggleModal={toggleModal}
            recipient={recipient}
          />
        </Modal>
      )}
      <div className="p-6">
        {/* Header Section */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-gray-900">Church Community</h2>
          <div className="flex space-x-2">
            <button
              onClick={() => setShowMessageComponent(true)}
              className="inline-flex items-center px-3 py-2 text-sm font-medium text-blue-600 bg-blue-50 rounded-md transition-colors duration-200 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <HiOutlineMailOpen className="w-4 h-4" />
              
            </button>
            <button
              onClick={handleRecipient}
              className="inline-flex items-center px-3 py-2 text-sm font-medium text-green-600 bg-green-50 rounded-md transition-colors duration-200 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            >
              <HiOutlineUserAdd className="w-4 h-4" />
            </button>
          </div>
        </div>

        {/* Search Section */}
        <div className="relative mb-6">
          <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
            <HiOutlineSearch className="w-5 h-5 text-gray-400" />
          </div>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="block py-2 pr-10 pl-10 w-full leading-5 placeholder-gray-400 bg-gray-50 rounded-md border border-gray-200 transition duration-150 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="Search community members..."
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery("")}
              className="flex absolute inset-y-0 right-0 items-center pr-3 text-gray-400 transition-colors duration-200 hover:text-gray-600"
              title="Clear search"
            >
              <HiX className="w-5 h-5" />
            </button>
          )}
        </div>

        {/* Buddies List */}
        <div className="space-y-4">
          {filteredBuddies.length > 0 ? (
            filteredBuddies?.slice(list_buddies)?.map((buddy) => (
              <div key={buddy?._id} className="flex justify-between items-center p-3 bg-gray-50 rounded-lg transition-colors duration-200 hover:bg-gray-100">
                <div className="flex items-center space-x-3">
                  <div className="flex-shrink-0">
                    {buddy?.image ? (
                      <img
                        crossOrigin="anonymous"
                        src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/family/${buddy?.image}`}
                        className="object-cover w-10 h-10 rounded-full border-2 border-white shadow-sm"
                        alt={`${buddy?.first_name}'s profile`}
                      />
                    ) : (
                      <div className="flex justify-center items-center w-10 h-10 bg-gray-200 rounded-full">
                        <HiOutlineUser className="w-6 h-6 text-gray-400" />
                      </div>
                    )}
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-gray-900">
                      {buddy?.first_name} {buddy?.last_name}
                    </h3>
                    <button
                      onClick={() => handleRecipient(buddy?._id)}
                      className="inline-flex items-center mt-1 text-xs text-blue-600 hover:text-blue-800"
                    >
                      <HiOutlineMail className="mr-1 w-4 h-4" />
                      Send Message
                    </button>
                  </div>
                </div>
                <button
                  onClick={() => removeBuddyfromList(buddy?._id)}
                  className="p-1 text-gray-400 rounded-full transition-colors duration-200 hover:text-red-500 hover:bg-red-50"
                  title="Remove from buddies"
                >
                  <HiX className="w-5 h-5" />
                </button>
              </div>
            ))
          ) : (
            <div className="py-8 text-center">
              <div className="inline-flex justify-center items-center w-16 h-16 bg-gray-100 rounded-full">
                <HiOutlineUser className="w-8 h-8 text-gray-400" />
              </div>
              <h3 className="mt-4 text-sm font-medium text-gray-900">
                {searchQuery ? "No matching members found" : "No Community Members"}
              </h3>
              <p className="mt-1 text-sm text-gray-500">
                {searchQuery 
                  ? "Try adjusting your search terms"
                  : "Start by adding some members to your community."}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatBuddySection;
